import {
  AddCard,
  DeleteForeverOutlined,
  DeleteOutline,
  FileCopy,
  PlusOneOutlined,
} from "@mui/icons-material";
import { useClickAway } from "@uidotdev/usehooks";
import React, { useRef } from "react";
import { IoDuplicate } from "react-icons/io5";
import { NavLink } from "react-router-dom";
import { useLanguage } from "../../Components/Localization/LanguageContext";
import strings from "../../Components/Localization/strings";

export default function ContextMenu({
  x,
  y,
  closeContextMenu,
  formId,
  sectionId,
  contextOptions,
  fieldId,
}) {
  const { language } = useLanguage();
  const pageTitle = "ContextMenu";
  const ref = useClickAway(() => closeContextMenu());

  // Function to calculate the adjusted y position
  const calculateAdjustedY = (y, menuHeight) => {
    const windowHeight = window.innerHeight;
    const distanceToBottom = windowHeight - y;

    if (distanceToBottom < menuHeight) {
      return y - menuHeight;
    }

    return y;
  };

  const styles = {
    top: `${calculateAdjustedY(y, 80)}px`,
    left: `${x}px`,
    position: "fixed",
    zIndex: 1000,
    background: "white",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  };

  const liStyles = {
    fontSize: "14px",
    padding: "10px",
    cursor: "pointer",
    borderBottom: "0.5px solid #ccc",
    display: "flex",
    alignItems: "center",
    width: "100%",
    ":hover": {
      background: "#eee",
    },
    color: "grey",
  };
  if (contextOptions === "formLevel")
    return (
      <ul ref={ref} onClick={() => closeContextMenu()} style={styles}>
        <NavLink to={`${formId}/addSection`} style={liStyles}>
          <AddCard sx={{ fontSize: "18px", marginRight: "5px" }} />
          {strings[pageTitle][language].addSection}
        </NavLink>
        <NavLink
          to={`/formsandfields/createform`}
          style={liStyles}
          state={{ formId: formId }}
        >
          <FileCopy sx={{ fontSize: `18px` }} />
          {strings[pageTitle][language].duplicateForm}
        </NavLink>
      </ul>
    );
  else if (contextOptions === "sectionLevel")
    return (
      <ul ref={ref} onClick={() => closeContextMenu()} style={styles}>
        <NavLink
          to={`${formId}/section/${sectionId}/addField`}
          style={liStyles}
        >
          <AddCard sx={{ fontSize: "18px", marginRight: "5px" }} />
          {strings[pageTitle][language].addField}
        </NavLink>
        <NavLink
          to={{
            pathname: `${formId}/section/${sectionId}`,
          }}
          state={{ showDeleteModal: true }}
          style={liStyles}
        >
          <DeleteOutline sx={{ fontSize: `18px` }} />
          {strings[pageTitle][language].deleteSection}
        </NavLink>
      </ul>
    );
  else if (contextOptions === "fieldLevel")
    return (
      <ul ref={ref} onClick={() => closeContextMenu()} style={styles}>
        <NavLink
          style={liStyles}
          to={{
            pathname: `${formId}/section/${sectionId}/field/${fieldId}`,
          }}
          state={{ showDeleteModal: true }}
        >
          <DeleteOutline sx={{ fontSize: `18px` }} />
          {strings[pageTitle][language].deleteField}
        </NavLink>
      </ul>
    );
}
